import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewControlPesoDiario = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'racion_autoconsumo',
        name: 'Racion Autoconsumo',
        component: ViewControlPesoDiario,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
